module.exports = __webpack_public_path__ + "img/LackingPrivateBath2.d0508b22.jpg";